/**
 * Get the color associated with a specific status.
 * @param {number} status - The status code.
 * @returns {string} - The color associated with the status.
 */
export const getStatusColor = (status) => {
    switch (status) {
        case 3: // Completed
            return '#7a6ad8';
        case 1: // Upcoming
            return '#ffc107';
        case 2: // In Progress
            return '#17a2b8';
        default:
            return '#6c757d';
    }
};

/**
 * Get the text associated with a specific status.
 * @param {number} status - The status code.
 * @returns {string} - The text associated with the status.
 */
export const getStatusText = (status) => {
    switch (status) {
        case 3:
            return 'مكتمل';
        case 1:
            return 'قادم';
        case 2:
            return 'قيد التنفيذ';
        default:
            return 'غير معروف';
    }
};